import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ViewlogyProvider } from 'context';
import Viewlogy from 'features/Viewlogy';
import Search from 'features/Search';
import SearchDownload from 'features/SearchDownload';
import Feedback from 'features/Feedback';
import SlideshowUpload from 'features/SlideshowUpload';
import Redirect404 from 'features/Redirect404';

// initialize google analytics

const PortalRedirect = () => {
    const { organizationId } = useParams();
    window.location.href = `https://portal.viewlogies.net/${organizationId}/login`;
    return null;
};

const App = () => (
    <div className="app-wrapper">
        <Helmet>
            <title>{'VIEWLOGIES'}</title>
        </Helmet>
        <ViewlogyProvider>
            <Router>
                <Routes>
                    <Route path="/:organizationId/schedule/login" element={<PortalRedirect />} />
                    <Route path="/:organizationId/schedule" element={<PortalRedirect />} />
                    <Route path="/locate" element={<Search />} />
                    <Route path="/download" element={<SearchDownload />} />
                    <Route path="/upload/:organizationId/:eventId" element={<SlideshowUpload />} />
                    <Route path="/feedback/:organizationId/:eventId" element={<Feedback />} />
                    <Route path="/:organizationId/:eventId" element={<Viewlogy />} />
                    <Route path="/:organizationId/:chapel/:startTime/:lastName" element={<Viewlogy />} />
                    <Route path="/" element={<Redirect404 />} />
                </Routes>
            </Router>
        </ViewlogyProvider>
    </div>
);

export default App;
